import "core-js/modules/es.object.freeze";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(createLead),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doJoinWaitlist),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(watchLeadGenFormSagas);

import { fetchEntity, fetchEntityIfNeeded } from '@classpass/saga-tools';
import { all, call, fork, select, spawn, takeEvery, put } from 'redux-saga/effects';
import { deepExtract } from 'helpers/deep';
import { ga } from 'helpers/multitrack';
import { trackOptimizelyEvent } from 'helpers/optimizely';
import { set as setUserType } from 'helpers/userTypeCookie';
import * as utmValues from 'helpers/utmValues';
import { waitlistRequest, glsLocation } from 'redux/saga/entities/bound';
import { selectUserLocale } from 'redux/modules/locale';
import { selectCmsPath } from 'redux/saga/selectors/cms';
import { persistUserLocation } from 'redux/saga/helpers/location';
import { setMsaId } from 'redux/modules/features/homepage';
export var CODE_BY_ERROR = Object.freeze({
  ALREADY_MEMBER: 4405,
  ALREADY_ON_WAITLIST: 4401,
  INVALID_EMAIL: 4402
});
var LEAD_GEN_JOIN_WAITLIST = 'LEAD_GEN_JOIN_WAITLIST';
export var joinWaitlist = function joinWaitlist(_ref) {
  var email = _ref.email,
      location = _ref.location,
      submissionType = _ref.submissionType;
  return {
    type: LEAD_GEN_JOIN_WAITLIST,
    email: email,
    location: location,
    submissionType: submissionType
  };
};
export function createLead(client, email, _ref2) {
  var locale, location, submissionType, utms;
  return regeneratorRuntime.wrap(function createLead$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          locale = _ref2.locale, location = _ref2.location, submissionType = _ref2.submissionType;
          _context.next = 3;
          return call(utmValues.getForApi);

        case 3:
          utms = _context.sent;
          _context.next = 6;
          return call(fetchEntity, waitlistRequest, [client, {
            conversion: utms,
            country_code: deepExtract('msa.country.code', location),
            email: email,
            gls_location_id: deepExtract('location.id', location),
            locale: locale,
            msa_id: deepExtract('msa.id', location),
            submission_type: submissionType
          }]);

        case 6:
          _context.next = 8;
          return call(setUserType, 'lead');

        case 8:
          _context.next = 10;
          return call(trackOptimizelyEvent, 'lead_capture');

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function doJoinWaitlist(client, _ref3) {
  var email, _ref3$location, lat, lon, submissionType, locale, location, path, errorCode, _path;

  return regeneratorRuntime.wrap(function doJoinWaitlist$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          email = _ref3.email, _ref3$location = _ref3.location, lat = _ref3$location.lat, lon = _ref3$location.lon, submissionType = _ref3.submissionType;
          _context2.prev = 1;
          _context2.next = 4;
          return select(selectUserLocale);

        case 4:
          locale = _context2.sent;
          _context2.next = 7;
          return call(fetchEntityIfNeeded, glsLocation, [client, lat, lon]);

        case 7:
          location = _context2.sent;
          _context2.next = 10;
          return call(createLead, client, email, {
            locale: locale,
            location: location,
            submissionType: submissionType
          });

        case 10:
          _context2.next = 12;
          return select(selectCmsPath);

        case 12:
          path = _context2.sent;
          _context2.next = 15;
          return all([spawn(ga, 'Lead Submission', 'successful_submission', path, 1), call(persistUserLocation, lat, lon), put(setMsaId(deepExtract('msa.id', location)))]);

        case 15:
          _context2.next = 40;
          break;

        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2["catch"](1);
          errorCode = deepExtract('code', _context2.t0);
          _context2.next = 22;
          return select(selectCmsPath);

        case 22:
          _path = _context2.sent;

          if (!(CODE_BY_ERROR.ALREADY_ON_WAITLIST === errorCode)) {
            _context2.next = 30;
            break;
          }

          _context2.next = 26;
          return call(setUserType, 'lead');

        case 26:
          _context2.next = 28;
          return spawn(ga, 'Lead Submission', 'duplicate_lead_error', _path, 1);

        case 28:
          _context2.next = 40;
          break;

        case 30:
          if (!(CODE_BY_ERROR.ALREADY_MEMBER === errorCode)) {
            _context2.next = 37;
            break;
          }

          _context2.next = 33;
          return call(setUserType, 'registered');

        case 33:
          _context2.next = 35;
          return spawn(ga, 'Lead Submission', 'email_associated_account_error', _path, 1);

        case 35:
          _context2.next = 40;
          break;

        case 37:
          if (!(CODE_BY_ERROR.INVALID_EMAIL === errorCode)) {
            _context2.next = 40;
            break;
          }

          _context2.next = 40;
          return spawn(ga, 'Lead Submission', 'invalid_email_error', _path, 1);

        case 40:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 17]]);
}
export function watchLeadGenFormSagas(client) {
  return regeneratorRuntime.wrap(function watchLeadGenFormSagas$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return fork(takeEvery, LEAD_GEN_JOIN_WAITLIST, doJoinWaitlist, client);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}